<header class="basic-header">
  <div class="basic-header__side basic-header__left">
    <div class="basic-header__hashtag">
      <a class="forevergreen" href="https://forevergreen.es/" title="#ForEverGreen" target="_blank">#FOREVERGREEN</a>
    </div>
  </div>
  <a class="basic-header__logo" href="/" aria-label="Real Betis">
    <img src="/assets/images/escudo-color.svg" alt="Real Betis" height="91" width="170" />
  </a>
  <div class="basic-header__side basic-header__right"></div>
</header>
